import React, { Component } from 'react';
import { removeSpaces } from '../../../../services/formatters/removeSpaces';
import { inject, observer } from 'mobx-react';
import ClosedServiceProvider from './closedServiceProvider';
import OpenServiceProvider from './openServiceProvider';

@inject('translationsStore', 'rolesStore') @observer
export default class ServiceProviderPermissions extends Component {

    state = {
        open: false
    }
    
    getPermissionsCount()
    {
        let permissionsCount = 0;
        this.props.data.categories.forEach(category => {
            category.data.forEach(permission => {
                if(this.props.rolesStore.permissionIds.includes(permission.id)){
                    permissionsCount ++;
                }
            });
        });

        return permissionsCount;
    }

    openServiceProvider = () => {
        this.setState({
            open: true
        });
    }

    closeServiceProvider = () => {
        this.setState({
            open: false
        });
    }

    render() {
        
        const data = this.props.data;
        const open = this.state.open;

        const serviceProviderName = removeSpaces(data.name);

        let item = null;

        if (open === true) {
            
            item = <OpenServiceProvider 
                        serviceProviderName={serviceProviderName}
                        permissionsCount={this.getPermissionsCount()}
                        onCloseServiceProvider={this.closeServiceProvider}
                        rolesStore={this.props.rolesStore}
                        categories={data.categories}/>;
                    }
        else {

            item = <ClosedServiceProvider 
                        serviceProviderName={serviceProviderName}
                        permissionsCount={this.getPermissionsCount()}
                        onOpenServiceProvider={this.openServiceProvider}/>;
        }

        return (
            <div style={{marginTop: 30}}>
                {item}
            </div>
        );
    }
}